import { gql } from '@apollo/client';

export const PENDING_PROFILE_CHANGES = gql`
    query ProfileChangeRequests($status: String, $first: Int, $offset: Int) {
        profileChangeRequests(status: $status, first: $first, offset: $offset) {
            totalCount
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            edges {
                node {
                    id
                    member {
                        id
                        firstName
                        lastName
                        email
                        image {
                            url
                            alt
                        }
                    }
                    requestedChangesDisplay
                    status
                    createdAt
                    reviewedBy {
                        firstName
                        lastName
                    }
                    reviewedAt
                    reviewComment
                }
            }
        }
    }
`;
